import React from "react";
import ReviewHub from "./ReviewHub";
import "../../../components/common/css/index.scss";

const ReviewHubIndex = () => {
  return (
    <div className="list">
      <div className="listContainer">
        <ReviewHub />
      </div>
    </div>
  );
};

export default ReviewHubIndex;
